import { FolderOutlined } from '@mui/icons-material';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useClassicNavigate } from '../../hooks/useClassicNavigate';
import {
  selectAppStatus,
  setDrawerOpen,
  setFolderListOpen,
  setRecentChatsOpen,
} from '../../redux/reducers/appStatusReducer';
import { selectFolders, setCurrentFolder } from '../../redux/reducers/folderReducer';
import { setSearchQuery } from '../../redux/reducers/navDrawerReducer';
import { AppDispatch } from '../../redux/store';
import { StyledDrawerButton } from '../../theme/CustomComponents';
import { Folder } from '../../Types/folder';
import { AnalyticsEvent, useAnalytics } from '../Providers/AnalyticsProvider';
import FolderList from './FolderList';

const DrawerFolderList: React.FC<{ folderListHeight: string }> = ({ folderListHeight }) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useClassicNavigate();
  const { drawerOpen } = useSelector(selectAppStatus);
  const { currentFolder } = useSelector(selectFolders);
  const analytics = useAnalytics();

  const onFolderCardClick = useCallback(
    (folder: Folder) => {
      analytics.event(
        AnalyticsEvent.WM_NIGEL_FOLDER_CLICK,
        {
          id: folder.id,
        },
        {
          folderId: folder.id,
        }
      );
      if (folder.id !== currentFolder?.id) {
        dispatch(setCurrentFolder(folder));
      }

      dispatch(setSearchQuery(''));

      navigate(`/folder/${folder.id}`);
    },
    [navigate, dispatch, analytics, currentFolder?.id]
  );

  return (
    <>
      {drawerOpen ? (
        <div
          id="folder-list"
          style={{
            paddingBottom: '10px',
            borderBottom: '1px solid #C4C4C4',
          }}
        >
          <FolderList onFolderCardClick={onFolderCardClick} folderListHeight={folderListHeight} />
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            padding: '5px 0px',
            alignItems: drawerOpen ? 'stretch' : 'center',
          }}
        >
          <StyledDrawerButton
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={() => {
              dispatch(setRecentChatsOpen(false));
              dispatch(setFolderListOpen(true));
              dispatch(setDrawerOpen(true));
            }}
          >
            <FolderOutlined sx={{ height: '20px', width: '20px', color: '#070154' }} />
          </StyledDrawerButton>
        </div>
      )}
    </>
  );
};

export default DrawerFolderList;
